import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-Volunteering/AdminEditVolunteering.css";
import Spinner from "../Spinner";

const AdminEditVolunteering = ({ onClose, productData, fetchData, projectKey }) => {
  const [uploadVolunteeringLogo, setUploadVolunteeringLogo] = useState(0);
  const [uploadVolunteeringCertificates, setUploadVolunteeringCertificates] =
    useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ...productData,
    volunteeringName: productData?.volunteeringName,
    volunteeringInstitute: productData?.volunteeringInstitute,
    volunteeringYear: productData?.volunteeringYear,
    volunteeringLogo: productData?.volunteeringLogo || [],
    volunteeringCertificates: productData?.volunteeringCertificates || [],
  });

  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.volunteeringName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadVolunteeringLogo(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              volunteeringLogo: [...prev.volunteeringLogo, downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadCertificates(e) {
    setLoading(true);
    const video = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.volunteeringName}-${video.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, video);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Image Upload is " + progress + "% done");
          setUploadVolunteeringCertificates(progress);
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              volunteeringCertificates: [
                ...(prev.volunteeringCertificates || []),
                downloadURL,
              ],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  const handleDeleteLogo = (index) => {
    //console.log("clicl");
    const newLogos = [...data.volunteeringLogo];
    newLogos.splice(index, 1);
    setData((pre) => {
      return {
        ...pre,
        volunteeringLogo: [...newLogos],
      };
    });
  };

  const handleDeleteCertificates = (index) => {
    const newCertificates = [...data.volunteeringCertificates];
    newCertificates.splice(index, 1);
    setData((pre) => ({
      ...pre,
      volunteeringCertificates: newCertificates,
    }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    //console.log(projectKey);
    const docRef = doc(db, "volunteering", projectKey);
    await updateDoc(docRef, data);
    setLoading(false);
    toast.success("Volunteering Updated");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Edit Volunteering</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="volunteeringName">Volunteering Name :</label>
          <input
            type="text"
            id="volunteeringName"
            placeholder="Enter Volunteering name"
            value={data.volunteeringName}
            name="volunteeringName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="volunteeringInstitute">Institute Name :</label>
          <input
            type="text"
            id="volunteeringInstitute"
            placeholder="Enter Institute Name"
            value={data.volunteeringInstitute}
            name="volunteeringInstitute"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="volunteeringYear">Year :</label>
          <input
            type="text"
            className="input"
            placeholder="Enter the Year"
            value={data.volunteeringYear}
            name="volunteeringYear"
            onChange={handleOnChange}
          />
          <label htmlFor="volunteeringLogo" className="label">
          Volunteering Logo :
          </label>
          <label htmlFor="volunteeringLogo">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Volunteering Logo</p>
                <input
                  type="file"
                  id="volunteeringLogo"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadVolunteeringLogo > 0 && uploadVolunteeringLogo < 100 && (
            <label
              style={{ color: "blue", textAlign: "center" }}
            >{`Upload is ${uploadVolunteeringLogo}% done`}</label>
          )}

          <div>
            {data.volunteeringLogo.length > 0 ? (
              <div className="image-preview">
                {data.volunteeringLogo.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Volunteering Logo</p>
            )}
          </div>

          <label htmlFor="volunteeringCertificates" className="label">
            Certificates:
          </label>
          <label htmlFor="volunteeringCertificates">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Volunteering Certificates</p>
                <input
                  type="file"
                  id="volunteeringCertificates"
                  className="hidden"
                  onChange={handleUploadCertificates}
                />
              </div>
            </div>
          </label>
          {uploadVolunteeringCertificates > 0 &&
            uploadVolunteeringCertificates < 100 && (
              <label
                style={{ color: "blue", textAlign: "center" }}
              >{`Upload is ${uploadVolunteeringCertificates}% done`}</label>
            )}

          <div>
            {data.volunteeringCertificates.length > 0 ? (
              <div className="image-preview">
                {data.volunteeringCertificates.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteCertificates(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">
                *Please Upload Volunteering Certificates
              </p>
            )}
          </div>
          <button className="submit-button">Update Volunteering</button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default AdminEditVolunteering;
